









































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { useHsaPendingTransactionStore } from "@/shared/store/hsaPendingTransaction";

@Component({
  components: {
    CurrencyAmount
  }
})
export default class PendingAmountRow extends Vue {
  hsaPendingTransactionStore = useHsaPendingTransactionStore();

  @Prop()
  amount: number;

  @Prop({required: false})
  username: string;

  @Prop({required: false})
  partnerId: number;

  isOpen = false;

  get moneyIncreasing (): boolean {
    return this.amount > 0;
  }

  toggleOpen (): void {
    this.isOpen = !this.isOpen;
  }
}

